import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useGetProductSharedEvidence } from '@/shared/hooks/api/productSharedEvidence'
import { useCanWriteOrgData } from '@/shared/hooks/useCanWriteOrgData'
import { V2ProductIdentificationGuidance } from '@/v2/components/V2ProductIdentificationGuidance'
import { V2RohsSharedEvidenceFileDialog } from '@/v2/components/rohs-legislation-briefing/V2RohsSharedEvidenceFileDialog'
import { V2RohsSharedEvidenceFileItem } from '@/v2/components/rohs-legislation-briefing/V2RohsSharedEvidenceFileItem'
import type { EmcBriefingStep } from '../../utils/emcLegislationBriefing'
import { V2EmcLegislationBriefingStepShell } from './V2EmcLegislationBriefingStepShell'

export function V2EmcProductIdentificationStep({
  step,
  index,
  productId,
}: {
  step: EmcBriefingStep
  index: number
  productId: string
}) {
  const { t } = useTranslation('common')
  const canWrite = useCanWriteOrgData()
  const [dialogOpen, setDialogOpen] = useState(false)
  const { data } = useGetProductSharedEvidence(productId)

  const fileName =
    data?.slots.find((slot) => slot.slotKind === 'PRODUCT_IDENTIFICATION')
      ?.fileName ?? null
  const hasFile = fileName != null

  return (
    <>
      <V2EmcLegislationBriefingStepShell
        step={step}
        index={index}
        actions={
          canWrite && !hasFile ? (
            <Button
              type='button'
              variant='outline'
              size='sm'
              onClick={() => {
                setDialogOpen(true)
              }}
            >
              {t('v2.pages.products.detail.sharedEvidence.actions.upload')}
            </Button>
          ) : undefined
        }
      >
        <V2ProductIdentificationGuidance />
        {hasFile ? (
          <V2RohsSharedEvidenceFileItem
            fileName={fileName}
            canWrite={canWrite}
            onEdit={() => {
              setDialogOpen(true)
            }}
          />
        ) : undefined}
      </V2EmcLegislationBriefingStepShell>
      <V2RohsSharedEvidenceFileDialog
        productId={productId}
        slotKind='PRODUCT_IDENTIFICATION'
        fileName={fileName}
        open={dialogOpen}
        onOpenChange={setDialogOpen}
      />
    </>
  )
}
